<mat-card class="mat-card-contract-concession">
  <mat-card-header>
    <mat-card-title>{{ 'contract-concession.title' | translate }}</mat-card-title>
    <!-- <mat-card-subtitle>Veuillez saisir tout les champs</mat-card-subtitle> -->
  </mat-card-header>
  <form [formGroup]="contractConcessionForm" (ngSubmit)="onSubmit()">
    <mat-card-content>

      <div class="content-row">
        <label class="content-row-label">{{ 'label.area' | translate }}</label>
        <span class="required-asterisk" *ngIf="isRequiredField('area')">*</span>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="area" type="number" autocomplete="off">
          <span matSuffix>m²</span>
        </mat-form-field>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'contract.zone-type' | translate}}</label>
        <span class="required-asterisk" *ngIf="isRequiredField('zone')">*</span>
        <mat-radio-group aria-label="Select an option" formControlName="zone" class="content-row-input">
          <mat-radio-button value="A">{{ 'contract.zone-a' | translate}}</mat-radio-button>
          <mat-radio-button value="B">{{ 'contract.zone-b' | translate}}</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'contract.fittedOutArea' | translate}}</label>
        <span class="required-asterisk" *ngIf="isRequiredField('isFittedOutArea')">*</span>
        <mat-radio-group aria-label="Select an option" formControlName="isFittedOutArea" class="content-row-input">
          <mat-radio-button value="true">{{ 'button.yes' | translate}}</mat-radio-button>
          <mat-radio-button value="false">{{ 'button.no' | translate}}</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'contract.accessibility' | translate}}</label>
        <span class="required-asterisk" *ngIf="isRequiredField('isGoodAccessibility')">*</span>
        <mat-radio-group aria-label="Select an option" formControlName="isGoodAccessibility" class="content-row-input">
          <mat-radio-button value="true">{{ 'contract.accessibility-good' | translate}}</mat-radio-button>
          <mat-radio-button value="false">{{ 'contract.accessibility-bad' | translate}}</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'contract.default-price' | translate}}</label>
        <div>
          <label>{{currentPriceIndex | number :'0.6' :'fr'}}</label> € ( <label>{{currentPrice | number :'0.6'
            :'fr'}} €</label> * <label>{{currentCoef | number :'0.4' :'fr'}}</label> )
        </div>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'label.price-not-index' | translate }}</label>
        <span class="required-asterisk" *ngIf="isRequiredField('price')">*</span>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="price" type="number" autocomplete="off" step="0.000001">
          <span matSuffix>€</span>
        </mat-form-field>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'label.price-index' | translate }}</label>
        <div class="content-row-input" style="justify-content: flex-start;display: flex;">
          <span>{{indexPrice | number :'0.6' :'fr'}}</span>
          <span matSuffix> €</span>
        </div>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'label.discount-percentage' | translate }}</label>
        <span class="required-asterisk" *ngIf="isRequiredField('percentageDiscount')">*</span>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="percentageDiscount" type="number" autocomplete="off">
          <span matSuffix>%</span>
        </mat-form-field>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'label.beginDate' | translate}}</label>
        <span class="required-asterisk" *ngIf="isRequiredField('startDate')">*</span>
        <mat-form-field class="content-row-input">
          <input matInput [matDatepicker]="startDate" formControlName="startDate" autocomplete="off" [min]="uiService.getMinDate()"
          [max]="uiService.getMaxDate()">
          <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
          <mat-datepicker #startDate [disabled]="contractConcessionForm.get('startDate')?.disabled"></mat-datepicker>
        </mat-form-field>
      </div>

    </mat-card-content>
    <mat-card-actions class="contract-concession-card-action">
      <button mat-raised-button color="warn" *ngIf="dialogRef" type="button" (click)="onCancel()">
        <mat-icon>clear</mat-icon> {{ 'button.cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" [disabled]="contractConcessionForm.invalid">
        <mat-icon>save</mat-icon> {{ 'button.save' | translate }}
      </button>
    </mat-card-actions>
  </form>
</mat-card>